/*
 * Copyright (c) 2019 Cédric Bodet.
 * The MIT License
 * http://www.opensource.org/licenses/mit-license
 */
import 'worldwindjs' //WorldWind global
import EnhancedWmsLayer from '../../globe/api/EnhancedWmsLayer'
import {CorsAnywhere} from "../CorsAnywhere";
import React from 'react'

/* global WorldWind */

export default class EcmwfPM10 extends EnhancedWmsLayer {
    constructor() {
        let cfg = {
            title: "Coarse Particulate matter (PM10)",
            service: CorsAnywhere + "http://apps.ecmwf.int/wms/&token=public",
            version: "1.3.0",
            layerNames: "composition_pm10",
        };

        super(cfg);

        this.urlBuilder.transparent = false;
    }

    doRender(dc) {
        super.doRender(dc);
        if (this.inCurrentFrame) {
            dc.screenCreditController.addCredit(
                "© ECMWF",
                WorldWind.Color.LIGHT_GRAY);
        }
    }

    getLayerDisplayInformation() {
        return (<div>
            <p>beyond gaseous pollution, atmosphere can be polluted by tiny particles of 10 micrometers diameter or less
                (coarse particles). These particles are often addressed as floating dust in suspension, fluid or solid
                state and are best known as particulate matter (PM). They are categorized dependent of their aerodynamic
                diameter, which is a diameter of sphere-shaped particle that shows the same behavior in atmosphere as
                dust particle. Particle matter such as PM10, PM2.5, PM1.0, PM0.1 by definition is fraction of particles
                which diameter is less than 10, 2.5, 1.0, 0.1 µm (1 µm = 1 millionth of a meter or 1 thousandth of a
                millimeter). Large particles (PM10) consists of substances such as dust, asbestos and lead, and can get
                into the lungs, while fine ones (PM2.5) include organic compounds and metals, and can penetrate deeper
                into the respiratory system.
            </p><p>
                Source of these particles are incomplete combustion, automotive emissions, forest fires, industry,
                agricultural burning. Exposure of the particle pollution is a health hazard. Due to its nature particles
                are small enough to be inhaled. While inhaled particle can travel deep into lungs which can cause heart
                and lungs disease as well as development respiratory disease in children. Inhaled particles can also go
                from lungs into blood steam and effect cardiovascular system.
            </p>
            <p><a href="http://www.irceline.be/en/documentation/faq/what-is-pm10-and-pm2.5" target="_blank" rel="noopener noreferrer">Read
                more
                here.</a></p>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'}}>
                <img
                    src={"https://apps.ecmwf.int/wms/?token=public&request=GetLegend&layers=composition_pm10&styles=sh_nipy_spectral_ch4_surface&width=350&height=50"}
                    alt={"Legend"}/>
            </div>
            <p style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'}}>
                μg/m³ (microgram per cubic metre)
            </p>
        </div>);
    }
}
